<script>
export default {
  data () {
    return {
      flickeroption2h: {
        title: {
          text: '2小时内10分钟闪变',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var tooltipTitleXAxis = [-120, -110, -100, -90, -80, -70, -60, -50, -40, -30, -20, -10, 0]
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value
            }
            return relVal
          }
        },
        legend: {
          data: ['A相', 'B相', 'C相'],
          // right: 30,
          top: 30,
          formatter: ''
        },
        grid: {
          y2: 40,
          x2: 50
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: '分钟',
          data: [-120, '', -100, '', -80, '', -60, '', -40, '', -20, '', 0]
        }],
        yAxis: [{
          type: 'value',
          max: 2,
          min: 0,
          axisLabel: {
            // formatter: '{value} %'
          }
        }],
        series: [{
          name: 'A相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'B相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'C相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }]
      },
      flickeroption24h: {
        title: {
          text: '24小时内2小时闪变',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var tooltipTitleXAxis = [-24, -22, -20, -18, -16, -14, -12, -10, -8, -6, -4, -2, 0]
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value
            }
            return relVal
          }
        },
        legend: {
          data: ['A相', 'B相', 'C相'],
          // right: 30,
          top: 30,
          formatter: ''
        },
        grid: {
          y2: 40,
          x2: 50
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: '小时',
          data: [-24, '', -20, '', -16, '', -12, '', -8, '', -4, '', 0]
        }],
        yAxis: [{
          type: 'value',
          max: 2,
          min: 0,
          axisLabel: {
            // formatter: '{value} %'
          }
        }],
        series: [{
          name: 'A相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'B相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'C相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }
        ]
      },
      flickerChart2h: {},
      flickerChart24h: {},
      flickerData: {},
      interval: null,
      lastTs: 0
      // flickerSelectOptions: [{
      //   value: 1,
      //   label: 'A相瞬时闪变'
      // }, {
      //   value: 2,
      //   label: 'B相瞬时闪变'
      // }, {
      //   value: 3,
      //   label: 'C相瞬时闪变'
      // }],
      // flickerSelectValue: 1
    }
  },
  watch: {
    '$store.state.highSpdMode' () {
      this.pollCommand()
    }
  },
  computed: {
    collection () {
      return this.$store.state.highSpdMode ? 'meter_fast_stable_data' : 'meter_stable_data'
    }
  },
  mounted () {
    this.flickerChart2h = this.$echarts.init(document.getElementById('flickeroptions2h'))
    this.flickerChart24h = this.$echarts.init(document.getElementById('flickeroptions24h'))

    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: this.collection,
          sn: this.$store.state.sn
        }).then((res) => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
          // else if (new Date().getTime() - res.data.data.ts > 900000) {
          //   if (this.interval) {
          //     clearInterval(this.interval)
          //     this.interval = null
          //   }
          //   this.timeOver = true
          // }
        })
      }, 1000)
    }
    this.pollCommand()
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.pollStop()
  },
  methods: {
    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand()
        if (!this.commandInterval) {
          this.commandInterval = setInterval(() => {
            this.sendCommand()
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.commandInterval) {
        clearInterval(this.commandInterval)
        this.commandInterval = null
      }
    },
    sendCommand () {
      this.$api.command({
        sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        lists: [[1, 6, 0]]
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    async updateData () {
      const params = {
        'collection': this.collection,
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'fields': ['sta', 'stb', 'stc', 'psta_arr', 'pstb_arr', 'pstc_arr', 'plta_arr', 'pltb_arr', 'pltc_arr']
      }
      const {data: res} = await this.$api.queryLastData(params)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      this.flickerData = res.data
      // console.log(data)
      this.flickeroption2h.series[0].data = res.data.psta_arr
      this.flickeroption2h.series[1].data = res.data.pstb_arr
      this.flickeroption2h.series[2].data = res.data.pstc_arr
      this.flickeroption24h.series[0].data = res.data.plta_arr
      this.flickeroption24h.series[1].data = res.data.pltb_arr
      this.flickeroption24h.series[2].data = res.data.pltc_arr
      this.flickerChart2h.setOption(this.flickeroption2h)
      this.flickerChart24h.setOption(this.flickeroption24h)
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">闪变趋势图界面</div>

      <div style="display: flex; flex-wrap: wrap;">
        <!--        <div-->
        <!--          style="width: 200px; display: flex; justify-content: space-between; align-items: center; margin-left: 30px">-->
        <!--          <div style="width: 50px">电气量</div>-->
        <!--          <div style="width: 150px">-->
        <!--            <el-select v-model="flickerSelectValue" placeholder="请选择">-->
        <!--              <el-option-->
        <!--                v-for="item in flickerSelectOptions"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value">-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </div>-->
        <!--        </div>-->
        <div
          style="display: flex; margin-left: 20px; height: 30px; line-height: 30px; align-items: center">
          <div>瞬时闪变</div>
          <el-button style="width: 130px; margin-left: 10px; font-size: 20px;">
            <div style="display: flex">
              <div style="width: 40%; margin-right: 5px">A相</div>
              <div style="width: 60%; text-align: center">{{Number(flickerData ? flickerData.sta : 0).toFixed(3)}}</div>
            </div>
          </el-button>
          <el-button style="width: 130px; margin-left: 10px; font-size: 20px;">
            <div style="display: flex">
              <div style="width: 40%; margin-right: 5px">B相</div>
              <div style="width: 60%; text-align: center">{{Number(flickerData ? flickerData.stb : 0).toFixed(3)}}</div>
            </div>
          </el-button>
          <el-button style="width: 130px; margin-left: 10px; font-size: 20px;">
            <div style="display: flex">
              <div style="width: 40%; margin-right: 5px">C相</div>
              <div style="width: 60%; text-align: center">{{Number(flickerData ? flickerData.stc : 0).toFixed(3)}}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div style="height: calc(100% - 90px); display: flex; margin-top: 10px">
        <div id="flickeroptions2h" style="height: 100%; width: 50%"></div>
        <div id="flickeroptions24h" style="height: 100%; width: 50%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.pg {
  height: calc(45vh - 50px);
}

.dataName {
  width: 10%;
}

.dataValue {
  width: 10%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px) / 11);
}

</style>



// WEBPACK FOOTER //
// src/pages/Trend/FlickerTrend/FlickerTrend.vue